import { render, staticRenderFns } from "./BriqAlert.vue?vue&type=template&id=1cad9153&lang=pug&"
import script from "./BriqAlert.vue?vue&type=script&lang=js&"
export * from "./BriqAlert.vue?vue&type=script&lang=js&"
import style0 from "./BriqAlert.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports